import React from "react";
import { Link } from "react-router-dom";
import { useHackathon } from "../contexts/HackathonContext";
import { groups } from "../data/groups";
import { groupProgress } from "../utils/progress";
import { subjectForGroup } from "../utils/subjects";
import { currentProgramDay, PROGRAM_DAYS } from "../utils/dates";
export function ProgressReportTable() {
  const {
    state
  } = useHackathon();
  const today = currentProgramDay();
  return <div className="overflow-x-auto rounded-xl border border-line bg-surface" data-id="element-283" data-mp="5d4trobaz8yt">
      <table className="w-full min-w-[760px] text-left text-sm" data-id="element-284" data-mp="aa50m1fz8fqz">
        <thead className="border-b border-line text-xs text-muted" data-id="element-285" data-mp="3rjtkbirvd7l1">
          <tr data-id="element-286" data-mp="3rlo0kjs74bis">
            <th scope="col" className="px-5 py-3 font-medium" data-id="element-287" data-mp="da0xf7yw9b4">Group</th>
            <th scope="col" className="px-3 py-3 font-medium" data-id="element-288" data-mp="bfjiavwmzbs">Track & product</th>
            <th scope="col" className="px-3 py-3 font-medium" data-id="element-289" data-mp="2g2uyhzzxuwcj">Milestones</th>
            <th scope="col" className="px-3 py-3 font-medium" data-id="element-290" data-mp="2l3ral0ug1ot1">Daily videos</th>
            <th scope="col" className="px-5 py-3 text-right font-medium" data-id="element-291" data-mp="3asi3o26kmj5p">Overall</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-line" data-id="element-292" data-mp="35ugjfdxesdsn">
          {groups.map(g => {
          const profile = state.groups.find(p => p.id === g.id);
          const p = groupProgress(profile, state.videos, g.id);
          const subject = subjectForGroup(g.id);
          return <tr key={g.id} className="transition-colors duration-150 hover:bg-paper" data-id="element-293" data-mp="3tr3zb1jbji28">
                <td className="px-5 py-4 align-top" data-id="element-294" data-mp="3osspgqt0x7k0">
                  <Link to={`/organizer/groups/${g.id}`} className="font-semibold hover:underline" data-id="element-295" data-mp="3osanrenle14p">
                    Group {g.id}
                  </Link>
                  <p className="mt-0.5 text-xs text-muted" data-id="element-296" data-mp="2cpwr91ydree">
                    {state.students.filter(s => s.groupId === g.id).map(s => s.name.split(" ")[0]).join(", ")}
                  </p>
                </td>
                <td className="px-3 py-4 align-top" data-id="element-297" data-mp="355w2fzalzgop">
                  <p className="font-medium" data-id="element-298" data-mp="357h0w001njru">{profile?.productName || <span className="text-muted" data-id="element-299" data-mp="396pun4v33hne">Product not named yet</span>}</p>
                  <p className="mt-0.5 text-xs text-muted" data-id="element-300" data-mp="3e6atlfa97q04">{subject ?? "Track not assigned"}</p>
                </td>
                <td className="px-3 py-4 align-top" data-id="element-301" data-mp="3ixkgw98byh8u">
                  <div className="flex items-center gap-2" data-id="element-302" data-mp="3iyc3wvnv36ni">
                    <div className="h-1.5 w-24 overflow-hidden rounded-full bg-line" data-id="element-303" data-mp="3nv2fp6smvg34">
                      <div className="h-full rounded-full bg-brgreen" style={{
                    width: `${p.milestonesDone / p.milestonesTotal * 100}%`
                  }} data-id="element-304" data-mp="3sup2a6ucq8ol" />
                    </div>
                    <span className="tabular-nums text-muted" data-id="element-305" data-mp="plbitj1n4gt">
                      {p.milestonesDone}/{p.milestonesTotal}
                    </span>
                  </div>
                </td>
                <td className="px-3 py-4 align-top" data-id="element-306" data-mp="22l5duuj9ummm">
                  <div className="flex items-center gap-1.5" aria-label={`${p.videosDone} of ${PROGRAM_DAYS} videos`} data-id="element-307" data-mp="27ix47k49q0op">
                    {Array.from({
                  length: PROGRAM_DAYS
                }, (_, i) => {
                  const d = i + 1;
                  const has = state.videos.some(v => v.groupId === g.id && v.day === d);
                  const missed = !has && d < today;
                  return <span key={d} title={`Day ${d}${has ? ": submitted" : missed ? ": missed" : ""}`} className={`h-3 w-3 rounded-sm ${has ? "bg-brgreen" : missed ? "bg-danger/70" : "bg-line"}`} data-id="element-308" data-mp="1lb1gnshvfga0" />;
                })}
                  </div>
                </td>
                <td className="px-5 py-4 text-right align-top text-base font-semibold tabular-nums" data-id="element-309" data-mp="24wo388g33gtx">{p.percent}%</td>
              </tr>;
        })}
        </tbody>
      </table>
    </div>;
}